<template>
    <div class="card mb-2" v-if="rendered">
        <table ref="adhoc" :data-dom="dom" class="data-table w-100" data-select="true" data-action="/api/report/adhoc">
        </table>
        <div class="card-footer bg-secondary"></div>
    </div>
</template>

<script>
export default {
    props: ['type', 'query', 'column_sets', 'selected_columns', 'saved_query', 'show_count'],
    data: function() {
        return {
            columns: {},
            existing_columns: {
                Placements: [
                    'placements.id',
                    'addresses.city',
                    'states.name',
                    'policyholders.name',
                    'companies.name',
                    'contacts.name',
                    'hotel_placements.check_out_date',
                    'placements.claim_number',
                    'placements.assigned_date',
                    'placements.move_in_date',
                    'placements.move_out_date',
                    'placements.closed_date',
                    'placements.lost_file',
                    'placements.type',
                    'placements.archived',
                ],
                Contacts: [
                    'contacts.id',
                    'placements.id',
                    'policyholders.name',
                    'contacts.name',
                    'companies.name',
                    'addresses.address',
                    'addresses.city',
                    'states.name',
                    'addresses.zip',
                    'contacts.email',
                    'contacts.cell',
                    'companies.office',
                    'companies.fax',
                ],
                Vendors: [
                    'vendors.id',
                    'placements.id',
                    'policyholders.name',
                    'vendors.name',
                    'vendors.appliances',
                    'vendors.furniture',
                    'vendors.houseware',
                    'vendor_contact.name',
                    'vendor_contact.phone',
                    'vendor_contact.fax',
                    'vendor_contact.email',
                ],
                Budgets: [
                    'budgets.*',
                    'placements.id',
                    'policyholders.name',
                ],
            },
            options: {
                Placements: {
                    columnDefs: [
                        {
                            render: function (data, type, row, meta) {
                                return meta.row + 1;
                            },
                            searchable: false,
                            orderable: false,
                            targets: 'col-count_col',
                        },
                        {
                            render: function(data, type, row){
                                return "<a href='/placement/edit/"+row.id+"'>"+data+"</a>";
                            },
                            targets: 'col-policyholder',
                        },
                    ],
                    buttons: [
                        { extend: 'excel', text: '<i class="fas fa-file-download"></i>' }
                    ]
                },
                Contacts: {
                    columnDefs: [
                        {
                            render: function (data, type, row, meta) {
                                return meta.row + meta.settings._iDisplayStart + 1;
                            },
                            searchable: false,
                            orderable: false,
                            targets: 'col-count_col',
                        },
                        {
                            render: function (data, type, row) {
                                return "<a href='/placement/edit/" + row.placement_id + "'>" + data + "</a>";
                            },
                            targets: 'col-policyholder'
                        },
                        {
                            render: function(data, type, row){
                                return "<a href='/crm/contact/"+row.id+"'>"+data+"</a>";
                            },
                            targets: 'col-name'
                        }
                    ],
                    buttons: [
                        { extend: 'excel', text: '<i class="fas fa-file-download"></i>' }
                    ]
                },
                Vendors: {
                    columnDefs: [
                        {
                            render: function (data, type, row, meta) {
                                return meta.row + meta.settings._iDisplayStart + 1;
                            },
                            searchable: false,
                            orderable: false,
                            targets: 'col-count_col',
                        },
                        {
                            render: function (data, type, row) {
                                return "<a href='/placement/edit/" + row.placement_id + "'>" + data + "</a>";
                            },
                            targets: 'col-policyholder'
                        },
                        {
                            render: function (data, type, row) {
                                return data ? '<i class="fa fa-check"></i>' : '<i class="fa fa-times text-danger"></i>';
                            },
                            targets: ['col-appliances', 'col-houseware', 'col-furniture']
                        }
                    ],
                    buttons: [
                        { extend: 'excel', text: '<i class="fas fa-file-download"></i>' }
                    ],
                },
                Budgets: {
                    columnDefs: [
                        {
                            render: function (data, type, row, meta) {
                                return meta.row + meta.settings._iDisplayStart + 1;
                            },
                            searchable: false,
                            orderable: false,
                            targets: 'col-count_col',
                        },
                        {
                            render: function (data, type, row) {
                                return "<a href='/placement/edit/" + row.placement_id + "'>" + data + "</a>";
                            },
                            targets: 'col-policyholder'
                        },
                        {
                            render: function (data, type, row) {
                                return data ? '<i class="fa fa-check"></i>' : '<i class="fa fa-times text-danger"></i>';
                            },
                            targets: 'col-corporate'
                        }
                    ],
                    buttons: [
                        { extend: 'excel', text: '<i class="fas fa-file-download"></i>' }
                    ]
                },
            }
        }
    },
    computed: {
        dom() {
            return `<"card-loader loading"><"d-flex card-header p-2"<"saved-query-name align-items-center d-flex">flB>r<"card-body p-0 dt-card-body"<"dt-table-wrapper"<"dt-sticky-header"> t>ip>`;
        },
        rendered() {
            return Object.keys(this.columns).length;
        },
        additional_column_sets() {
            let i = 0;
            return Object.assign({}, ...this.query.where.map(q => {
                for (let x = 0; x < this.existing_columns[this.type].length; x++) {
                    const existing_columns = this.existing_columns[this.type][x];
                    if (existing_columns.includes('.*') && existing_columns.split('.')[0] === q.field.query.split('.')[0]) {
                        return false;
                    }
                }

                if (!this.existing_columns[this.type].includes(q.field.query)) {
                    i++;
                    return { ['additional_column_' + i]: q.field.text };
                }
            }));
        },
        additional_columns() {
            let i = 0;
            return this.query.where.map(q => {
                for (let x = 0; x < this.existing_columns[this.type].length; x++) {
                    const existing_columns = this.existing_columns[this.type][x];
                    if (existing_columns.includes('.*') && existing_columns.split('.')[0] === q.field.query.split('.')[0]) {
                        return false;
                    }
                }

                if (!this.existing_columns[this.type].includes(q.field.query)) {
                    i++;
                    return q.field.query;
                }
            });
        },
        selected_column_sets() {
            if (!this.selected_columns) return this.column_sets[this.type];

            const columns = {};
            Object.keys(this.column_sets[this.type])
                .filter(col => this.selected_columns[this.type][col] && this.selected_columns[this.type][col] != 'false')
                .forEach(col => columns[col] = this.column_sets[this.type][col]);
            return columns;
        },
    },
    methods: {
        instance() {
            let vm = this;
            const count_col = String(this.show_count) == 'true' ? { count_col: '#' } : {};
            this.$set(this, 'columns', {...count_col, ...this.selected_column_sets, ...this.additional_column_sets});
            let table = $(vm.$el).find('.data-table');
            if (table.data('chunk')) table.data('chunk').abort();

            this.$nextTick(function() {
                let table = $(vm.$el).find('.data-table');
                if ($.fn.dataTable.isDataTable(table)) {
                    table.DataTable().destroy();
                    table.empty();
                }
                vm.header();
                table.data('post_data', {...vm.query, ...{
                    additional_columns: vm.additional_columns
                }});
                table.data('options', vm.options[vm.type]);
                window.dataTableInstance(table);
                const queryName = document.querySelector('.saved-query-name');
                if (queryName) {
                    queryName.innerHTML = this.saved_query && this.saved_query.name ? `<h4 class="m-0 mr-4 pl-2">Saved Query - ${this.saved_query.name}</h4>` : '';
                }
            });
        },
        header() {
            let header =
            '<thead>'+
                '<tr>';

            for (let i in this.columns) {
                header += '<td data-column="'+i+'" class="col-'+i+'">'+this.columns[i]+'</td>';
            }

            header +=
                '</tr>' +
            '</thead>';

            $(this.$el).find(".data-table").html(header);
        }
    },
    mounted() {
        this.$parent.adhoc = this;
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/reports/adhoc.vue